import request from '../../api/base';
import axios from 'axios';
import {ObjectId} from '../../util/object.id'
import {message} from 'antd'
// cl:logo、ca:招聘简章、cp:形象照片、cv:宣传视频、cli:资质认证、cb:招聘模板banner
/**
 * 生成上传的文件名
 * @param key - 从服务器获取的上传key
 * @param filename - 用户选中的文件名
 * @return {string}
 */
function calculateFileName(key, filename) {
    const suffix = getFileExt(filename)
    return `${key}/${new ObjectId().toString()}${suffix}`
}

/**
 * 获取文件扩展名
 * @param filename
 * @return {string}
 */
function getFileExt(filename) {
    const pos = filename.lastIndexOf('.')
    let suffix = ''
    if (pos !== -1)
        suffix = filename.substring(pos)
    return suffix
}
//获取秘钥
export function getOssSecret(data) {
    return request.get('/Upload/GetOssSecret', data)
}

//获取图库秘钥
export function getYunYingOssSecret(data) {
    return request.get('/Upload/GetYunYingOssSecret', data)
}

export function ossRequest(data,file, fileName) {
    const formData = new FormData();
    const key = calculateFileName(data.dir,fileName?fileName:file.file.name)
    formData.append('key', key)
    formData.append('policy', data.policy)
    formData.append('OSSAccessKeyId', data.accessid)
    formData.append('success_action_status', 200)
    formData.append('signature', data.signature)
    formData.append('file', file.file);
    message.loading('正在上传...',30)
    return new Promise(function (resolve, reject) {
        return axios.post(data.host, formData,{
            onUploadProgress: ({ total, loaded }) => {
                file.onProgress({ percent: Math.round(loaded / total * 100).toFixed(2),fileUrl:data.host+'/'+key}, file.file);
            },
        })
            .then((response) => {
                message.destroy()
                resolve(data.host+'/'+key);
            }).catch((error) => {
                reject(error);
            });
    });
}

export function ossRequest2(data,file, fileName) {
    const formData = new FormData();
    const key = calculateFileName(data.dir,fileName?fileName:file.file.name)
    formData.append('key', key)
    formData.append('policy', data.policy)
    formData.append('OSSAccessKeyId', data.accessid)
    formData.append('success_action_status', 200)
    formData.append('signature', data.signature)
    formData.append('file', file.file);
    message.loading('正在上传...',30)
    return new Promise(function (resolve, reject) {
        return axios.post(data.host, formData,{
            onUploadProgress: ({ total, loaded }) => {
                file.onProgress({ percent: Math.round(loaded / total * 100).toFixed(2),fileUrl:data.host+'/'+key}, file.file);
            },
        })
            .then((response) => {
                message.destroy()
                resolve({title:file.file.name.replace(/\.[^/.]+$/,""),picUrl:data.host+'/'+key});
            }).catch((error) => {
                reject(error);
            });
    });
}